<template>
  <div class="goodsSync">
<!--    <div class="importMes">说明:<span>一键同步</span>即将前100条商品同步，无需勾选；<span>批量同步</span>需要勾选所需同步的商品，至多100条</div>-->
    <div class="importMes">说明:<span>批量同步</span>需要勾选所需同步的商品，至多100条</div>
    <search-form-template
      ref="goodsSync"
      :searchOptions="searchOptions"
      @clear="searchClear"
      @searchSubmit="searchSubmit"
      @btnCommon="btnCommon"
      :toolConfig="toolConfig"
    ></search-form-template>
    <el-table
      class="list"
      v-loading="loading"
      header-row-class-name="table-header"
      :ref="tableOptions.tableName"
      :data="tableData"
      @selection-change="handleSelectionChange"
      :header-row-style="{height:'28px',lineHeight:'28px'}"
      @row-click="rowClick"
      row-key="id"
      @select="rowSelect"
      @select-all="rowSelect"
      :max-height="400"
    >
      <!--多选-->
      <el-table-column v-if="isSelect" type="selection" width="55"></el-table-column>
      <!--索引-->
      <el-table-column
        align="center"
        type="index"
        width="60"
        label="序号"
      ></el-table-column>
      <el-table-column
        v-for="(column,index) in (tableOptions.columns)"
        :key="index"
        :class-name="column.class"
        :property="column.prop"
        :label="column.label"
        :align="column.align ||tableOptions.align"
        :min-width="column.width || tableOptions.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-show="scope.$index < tableData.length" :style="{height:'30px',lineHeight:'30px'}">
            <span v-if="column.type =='index'">{{ scope.$index + 1 }}</span>
            <el-input
              v-else-if="column.type == columnType.input"
              @change="valueChange(column,scope.row,scope.$index)"
              v-model="scope.row[column.prop]"
              :disabled="tableOptions.disabled"
            ></el-input>
            <el-input-number
              v-else-if="column.type == columnType.inputNumber"
              @change="valueChange(column,scope.row,scope.$index)"
              :precision="column.precision||null"
              v-model="scope.row[column.prop]"
              :min=0
              :disabled="tableOptions.disabled"
            ></el-input-number>
            <div v-else-if="column.enumData" v-html="$utils.getEnumItem(column,scope.row[column.prop])"></div>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </div>
          <div v-show="scope.$index == tableData.length">
            {{ scope.row[column.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box" style="padding-top:10px">
      <div class="fl total-cue">所有记录</div>
      <div class="fl total-cue">{{ page.total }}条</div>
      <!--分页-->
      <el-pagination
        class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-size="page.pageSize"
        :page-sizes="[10, 15, 20, 30, 40,100]"
        layout="sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
    <div
      v-loading.fullscreen.lock="onloading"
      element-loading-text="加载中,请稍后。。。"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(225, 225, 225, 0.8)"
    >
    </div>
  </div>
</template>

<script>
import searchFormTemplate from '../template/searchFormTemplate';
import tableTemplate from '../template/tableTemplate';
import api from '@/config/api';
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  components: {tableTemplate, searchFormTemplate},
  props: {
    isSelect: {
      type: Boolean,
      default: () => {
        return false;
      }
    },

    tableOptions: {
      type: Object,
      default: () => {
        return {
          maxHeight:600,
          tableName: "goodsTable",
          stripe: false, //是否斑马纹
          border: false, //是否带边框
          height: 500, //表格高度 单位px
          fixed: false, //string, boolean  true, left, right true 表示固定在左侧 表格左侧或右侧一列固定
          showSelect: false, // 是否显示选择框
          template: "", //自定义列模板 传入模板名称
          indexShow: false, //是否显示索引
          indexMethod: this.getIndex,
          columns: [
            {label: "ID", prop: "id", width: "100"},
            {label: "名称", prop: "name", width: "100"}
          ],
          url: "",
          param: {}
        };
      }
    },
  },
  data() {
    return {
      tableRow: {},
      columnType: this.$utils.columnType,
      onloading:false,
      loading: false,
      searchParam: {},
      tabelSelectRows: [],
      tableData: [],
      searchOptions: {
        hiddenReset:true,
        labelWidth:'80px',
        simple: [
          {
            formType:"insert",
            label: '',
            prop: 'storeId',
            type: 'select',
            clearable:true,
            placeholder:'选择门店',
            labelKey:'storeName',
            uniqueKey:'subStoreId',
            data: [],
            // url: api.store.store,
            span:6,
            disabled: false,
            change:this.selectStore,
          },
          {
            label: '',
            placeholder:'选择品牌',
            prop: 'goodsBrandId',
            type: 'select',
            data: [],
            // url: api.archives.brand,
            span:6,
          },
          {
            label: '',
            placeholder:'选择供应商',
            prop: 'supplierId',
            type: 'select',
            data: [],
            // url: api.archives.supplier,
            span:6,
          },
          {
            label: '',
            placeholder:'选择类别',
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 6,
            url: api.archives.getCategoryTree,
          },
        ]
      },
      toolConfig: [
        // {
        //   label: '一键同步',
        //   code: 'insert',
        //   callback: this.getSync,
        //   filter
        // },
        {
          label: '批量同步',
          code: 'batchModifying',
          callback: this.batchSync
        },
      ],
      page: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      params: {},
      storeList:[],
      searchForm:{
        subStoreId:'',
        relateType:null
      },
    }
  },
  beforeCreate() {

  },
  created() {
    this.getStoreList()
    // this.setStoreId(this.searchOptions.simple)
  },
  mounted() {
    let userInfo = this.$utils.getSysUser();
    // 门店设置默认值
    if(userInfo.storeId){
      // this.getTableData();
      // this.storeChange();
    }else{
      // this.isDisabled = false
      // this.selectStore({storeId: -1})
    }
    this.initData();
    this.tableData = []
    //
  },
  methods: {
    // 获取门店
    getStoreList(){
      let storeId = this.searchOptions.simple.filter(item => item.prop === 'storeId')[0]
      let user = this.$utils.getSysUser();
      this.$axios.fetchPost(api.takeout.takeoutStore + '/list', {status:20}).then(res => {
        if (res.code === 200) {
          storeId.data = res.data
          // if(res.data.length>0){
          //   if(user.storeId){
          //     this.$refs['goodsSync'].formModel.storeId = user.storeId;
          //   }else {
          //       res.data.forEach(v=>{
          //         if(v.relateType === 10){
          //           this.searchForm.relateType = v.re
          //           this.$refs['goodsSync'].formModel.storeId = v.subStoreId;
          //           this.tableOptions.param.storeId = -1
          //         }
          //       })
          //     }
          //     this.tableOptions.param.storeId = this.$refs['goodsSync'].formModel.storeId
          //     this.searchForm.subStoreId = this.$refs['goodsSync'].formModel.subStoreId
          //     // this.tableOptions.url = api.takeout.cdGoods
          //     // this.$refs['cdGoodsTemplate'].searchSubmit(this.tableOptions.param)//查询
          //   this.searchSubmit(this.tableOptions.param)
          //   }
        }
      });
    },
    // 选择门店
    selectStore(form){
      form.goodsBrandId = '';
      form.supplierId = '';

      let goodsBrandId = this.searchOptions.simple.filter(item => item.prop === 'goodsBrandId')[0]
      let supplierId = this.searchOptions.simple.filter(item => item.prop === 'supplierId')[0]

      this.searchOptions.simple.filter(item => item.prop === 'storeId')[0].data.forEach(v=>{
        if(form.storeId === v.subStoreId){
          this.searchForm.subStoreId = v.storeId // 批量同步需要的参数
          this.searchForm.relateType = v.relateType
        }
      })
      let paramId
      if(this.searchForm.relateType === 10){
        paramId = -1
      }else{
        paramId = form.storeId
      }
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: paramId}).then(data => {
        if (data.code === 200) {
          goodsBrandId.data = data.data;
        }
      });
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: paramId}).then(data => {
        if (data.code === 200) {
          supplierId.data = data.data;
        }
      })
    },
    //如果是门店登录的时候目标门店是不可编辑的
    storeChange() {
      let user = this.$utils.getSysUser();
      if (user.storeId) {
        this.searchOptions.simple.filter(item => item.prop === 'storeId')[0].disabled = true;
        this.$nextTick(() => {
          this.$refs['goodsSync'].formModel.storeId = user.storeId;
          this.selectStore({storeId: user.storeId})
        })
      }
    },
    //获取数据
    getTableData() {
      let searchParam = {
        pageNumber: this.page.current,
        pageSize: this.page.pageSize
      };
      Object.assign(searchParam, this.tableOptions.param || {});
      let param = this.$refs['goodsSync'].getSimpleParams();
      Object.assign(searchParam, param);
      // if (param.storeId === undefined) {
      //   this.$message({message: "门店不能为空!", type: "warning"});
      // } else {
        if(this.searchForm.relateType === 10){
          searchParam.storeId = -1
        }
          this.loading = true;
          this.$axios.fetchPost(this.tableOptions.url + "/page", searchParam)
            .then(data => {
              this.loading = false;
              if (data.code === 200 && data.data) {
                this.tableData = data.data.records;
                this.tableData.map(item => {
                  item.inventoryNum = 0.00.toFixed(2);
                });
                this.page.total = data.data.total;
              } else {
                this.$message({message: "请求失败！", type: "error"});
              }
            })
            .catch(err => {
              console.log(err);
              this.$message({message: "请求失败！", type: "error"});
              this.loading = false;
            });
        // }
    },
    //翻页
    handleCurrentChange(value) {
      this.page.current = value;
      this.getTableData();
    },
    //选中项
    handleSelectionChange(val) {
      this.selectRow = val;
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.current = 1;
      this.getTableData();
    },
    //清除选中
    clearSelection() {
      this.$refs[this.tableOptions.tableName].clearSelection();
    },

    searchClear() {
      // this.tableOptions.param = {}
      // this.$refs.goodsSync.simpleClear()
      this.searchForm = {
        subStoreId: "99999",
        relateType: 0
      }
      this.searchParam = {};
      this.getTableData({});
    },
    //查询
    searchSubmit(param) {
      this.tableOptions.param = param;
      this.getTableData();
    },
    rowClick(row, column, event) {
      if (this.isSelect) return;
      this.$emit('rowCheck', row);
    },
    //一键同步
    getSync() {
      if (this.tableData.length === 0) {
        this.$message({message: '没有数据可一键同步！', type: 'info'});
      } else {

      }
    },
    //批量同步
    batchSync() {
      if (this.tabelSelectRows.length === 0) {
        this.$message({message: '请勾选您要同步的商品！', type: 'warning'});
      } else {
        console.log(this.searchForm)
        this.tabelSelectRows.map(v=>{
          v.subPid = v.goodsId
          v.price = v.retailPrice
          // v.subStoreId = this.searchForm.subStoreId
        })
        // this.onloading = true
        this.$loading({text:'提交中，请稍后。。。'})
        this.$axios.fetchPost(api.takeout.cdGoods+'/sync', {
          goodsList: this.tabelSelectRows,
          subStoreId:this.searchForm.subStoreId,
          relateType: this.searchForm.relateType
        }).then(data => {
          if (data.code === 200) {
            this.$emit('close')
          }else{
            this.$message({message: '商品一键同步失败！'+data.errorMsg, type: 'error'});
          }
        }).finally(()=>{
          this.$loading({}).close()
        })
      }
    },
    rowSelect(selection) {
      this.tabelSelectRows = selection;
    },

    initData() {
      this.tableOptions.columns.map(column => {
        if (column.prop)
          this.tableRow[column.prop] = '';
        if (column.type == 'inputNumber')
          this.tableRow[column.prop] = undefined;
      });
      this.$set(this.tableData, 0, this.tableRow);
    },
    valueChange(column, row, index) {
      this.$forceUpdate();
      column.change && column.change(row, index);
    },
    btnCommon(btnObj) {
      btnObj.callback && btnObj.callback();
    },
    getNewData() {
      this.$parent.$parent.$refs.goodsInfo.operationSuccess()
    }
  },

}
</script>

<style scoped>
.goodsSync {
  height: 480px;
  margin-bottom: 20px;
}

.importMes {
  margin-left: 10px;
  color: red;
  margin-bottom: 10px;
  /*width: 48%;*/
}

.importMes span {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/business/takeoutGoods.vue